import { useState } from 'react';
import { Chip, IconButton, Stack, TextField, Tooltip } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { PoDetailDialog } from './PoDetailDialog';
import { poApi, type Po } from '../../api/procurement.api';

const STATUS_COLOR: Record<string, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
  draft: 'default', pending_approval: 'warning', approved: 'success', in_transit: 'info',
  partially_received: 'warning', received: 'success', closed: 'default', cancelled: 'error',
};

export function PoListPage() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [detailId, setDetailId] = useState<number | null>(null);
  const { data, isLoading } = useQuery({ queryKey: ['pos', page, search], queryFn: () => poApi.list({ page, limit: 25, search: search || undefined }) });

  const columns: Column<Po>[] = [
    { key: 'code', label: 'PO No.', width: 150 },
    { key: 'vendorId', label: 'Vendor', width: 90 },
    { key: 'grandTotal', label: 'Grand Total', render: (r) => `₹${r.grandTotal.toLocaleString()}` },
    { key: 'status', label: 'Status', render: (r) => <Chip size="small" label={r.status} color={STATUS_COLOR[r.status] ?? 'default'} /> },
  ];

  return (
    <>
      <PageHeader title="Purchase Orders" />
      <Stack direction="row" mb={2}><TextField size="small" placeholder="Search PO" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} /></Stack>
      <DataTable
        columns={columns} rows={data?.data ?? []} loading={isLoading}
        page={page} limit={25} total={data?.meta.total ?? 0} onPageChange={setPage} onLimitChange={() => undefined} rowKey={(r) => r.id}
        actions={(r) => <Tooltip title="Open"><IconButton size="small" onClick={() => setDetailId(r.id)}><Visibility fontSize="small" /></IconButton></Tooltip>}
      />
      <PoDetailDialog poId={detailId} onClose={() => setDetailId(null)} />
    </>
  );
}
